<template>
  <v-autocomplete
    v-model="model"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    :label="label"
    :prepend-icon="icon"
    :clearable="true"
    dense
    item-text="name"
    return-object
    hide-selected
    hide-no-data
    autocomplete="off"
    @change="signalChange"
  />
</template>

<script>
export default {
  name: "StoreSelect",
  props: {
    autoclear: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "mdi-store",
    },
    label: {
      type: String,
      default: "Store",
    },
    value: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    items: [],
    loading: false,
    search: "",
  }),
  computed: {
    model: {
      get: function () {
        return this.value
          ? Object.keys(this.value).length
            ? this.value
            : null
          : null;
      },
      set: function (val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    model() {
      this.$nextTick(() => {
        if (this.autoclear) {
          this.search = "";
          this.model = null;
        }
      });
      // Make sure the passed prop is part of items
      this.items.push(this.model);
    },
    search() {
      this.getStores();
    },
  },
  mounted() {
    this.getStores();
  },
  methods: {
    signalChange: function (event) {
      this.$emit("change", event);
    },
    getStores() {
      // Items have already been requested
      if (this.loading) {
        return;
      }

      this.loading = true;

      let filter = {
        page: {
          number: 1,
          size: 200,
        },
        filter: {},
      };

      if (this.search) {
        filter.filter.search = this.search;
      }

      this.$models.Store.all(filter)
        .then((response) => {
          this.items = response.data;
          this.items.push(this.model);
          this.loading = false;
        })
        .catch((error) => {
          this.$bus.$emit("Error", error);
        });
    },
  },
};
</script>
